// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1PRxh","errorLogs":"styles_errorLogs__3ZHWM"};